/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SravniDataNormalizationPagedModel1SravniNewsSharedModelsCommentsCommentReadModelSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  items?: SravniNewsSharedModelsCommentsCommentReadModel[] | null;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  total?: number;
}

export interface SravniIdentityClientsSubscriptionInfo {
  types?: SravniIdentitySubscriptionType[] | null;
  source?: string | null;
  /** @format date-time */
  date?: string | null;
}

export interface SravniIdentityClientsUser {
  /** @format int32 */
  id?: number;
  username?: string | null;
  /** @format date-time */
  registerDate?: string;
  pseudonym?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  /** @format int32 */
  companyId?: number | null;
  gender?: SravniIdentityGender;
  locality?: string | null;
  localityRoute?: string | null;
  otac?: string | null;
  phone?: string | null;
  email?: string | null;
  unconfirmedEmail?: string | null;
  subscriptions?: SravniIdentityClientsSubscriptionInfo;
  emailConfirmationToken?: string | null;
  hasPassword?: boolean;
}

export enum SravniIdentityGender {
  Male = 'male',
  Female = 'female',
}

export enum SravniIdentitySubscriptionType {
  CommentsNotifications = 'commentsNotifications',
  OrdersNotifications = 'ordersNotifications',
  News = 'news',
  Targeted = 'targeted',
}

export interface SravniMicroErrorsError {
  code?: string | null;
  target?: string | null;
  message?: string | null;
  attemptedValue?: string | null;
  details?: SravniMicroErrorsError[] | null;
}

export interface SravniMicroErrorsErrorModel {
  error?: SravniMicroErrorsError;
}

export interface SravniNewsDataModelsDictionaryDto {
  name?: string | null;
  alias?: string | null;
  value?: string | null;
  iconUrl?: string | null;
}

export interface SravniNewsDataModelsDictionaryResult {
  items?: SravniNewsDataModelsDictionaryDto[] | null;
}

export enum SravniNewsDataModelsImportanceDegree {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
}

export interface SravniNewsDataModelsMaterial {
  /** @format int32 */
  id?: number;
  title?: string | null;
  htmlHead?: string | null;
  htmlBody?: string | null;
  picture?: SravniNewsDataModelsPicture;
  miniPicture?: SravniNewsDataModelsPicture;
  targeting?: string | null;
  ogTitle?: string | null;
  ogDescription?: string | null;
  /** @format date-time */
  createDate?: string;
  /** @format date-time */
  lastChangeDate?: string;
  /** @format date-time */
  publishDate?: string;
  alias?: string | null;
  lead?: string | null;
  signature?: string | null;
  authorName?: string | null;
  authorLastName?: string | null;
  rubric?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
  importance?: SravniNewsDataModelsImportanceDegree;
  mainOrganizationId?: string | null;
  productTags?: string[] | null;
  taggedOrganizationIds?: number[] | null;
  tags?: string[] | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  seoKeywords?: string | null;
  /** @format int32 */
  visits?: number;
  noIndex?: boolean;
  showTableOfContents?: boolean;
  tinkoffInvestmentsTags?: string | null;
  externalLink?: string | null;
  externalId?: string | null;
  externalType?: SravniNewsSharedEnumsExternalMaterialType;
  lookButtonText?: string | null;
  passButtonText?: string | null;
  calculateButtonText?: string | null;
  answerButtonText?: string | null;
  templateType?: SravniNewsSharedEnumsMaterialTemplateType;
  isWebflow?: boolean;
  webflowHead?: string | null;
  webflowBody?: string | null;
  advertisingShieldText?: string | null;
  /** @format int32 */
  priorityOnMain?: number;
  /** @format int32 */
  priorityOnList?: number;
  /** @format int32 */
  priorityOnScroll?: number;
  /** @format int32 */
  priorityOnAdditionalReading?: number;
  hideAds?: boolean;
  /** @format int32 */
  commentsCount?: number;
  canCreateNewComments?: boolean;
  projectName?: string | null;
  authors?: SravniNewsSharedModelsAuthorsAuthorReadModel[] | null;
  relationTo?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  organizationData?: SravniOrganizationsSharedOrganizationData;
  /** @format int64 */
  likes?: number;
  isTargetPlacement?: boolean;
  placementTags?: string[] | null;
  placementProductTags?: string[] | null;
  placementSeoContentCategoryTags?: string[] | null;
  placementSeoContentSubCategoryTags?: string[] | null;
  interestingOfferTypes?: string[] | null;
  isEncyclopedia?: boolean;
}

export interface SravniNewsDataModelsPicture {
  url?: string | null;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface SravniNewsDataModelsPlacementConfiguration {
  placementType?: SravniNewsSharedEnumsPlacementType;
  /** @format int32 */
  maxItems?: number;
  materials?: SravniNewsDataModelsMaterial[] | null;
}

export interface SravniNewsDataModelsResult1SystemCollectionsGenericList1SravniNewsSharedModelsMaterialsHighLightSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNullSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798E {
  items?: SravniNewsSharedModelsMaterialsHighLight[][] | null;
}

export interface SravniNewsDataModelsRubricDictionaryResult {
  items?: SravniNewsDomainRubricResultModel[] | null;
}

export interface SravniNewsDataModelsTag {
  /** @format int64 */
  id?: number;
  alias?: string | null;
  name?: string | null;
  isPrivate?: boolean;
  isSpecialProjects?: boolean;
}

export interface SravniNewsDataModelsUserContentReadModel {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  date?: string;
  text?: string | null;
  title?: string | null;
  rubric?: string | null;
  rubricAlias?: string | null;
  /** @format int32 */
  commentsCount?: number;
  /** @format int64 */
  likes?: number;
  picture?: string | null;
  alias?: string | null;
  /** @format date-time */
  publishDate?: string;
  type?: SravniNewsSharedEnumsMaterialType;
}

export interface SravniNewsDomainAuthorBlock {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  created?: string;
  name?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  cause?: string | null;
  /** @format int32 */
  blockedBy?: number;
  blockedByContact?: string | null;
  isUnblocked?: boolean;
  /** @format date-time */
  unblockedDate?: string | null;
  /** @format int32 */
  unblockedBy?: number | null;
  unblockedByContact?: string | null;
}

export interface SravniNewsDomainRubricResultModel {
  /** @format int64 */
  id?: number;
  name?: string | null;
  alias?: string | null;
  /** @format int32 */
  menuOrder?: number | null;
  iconUrl?: string | null;
  isPrivate?: boolean;
  value?: string | null;
}

export interface SravniNewsServiceV1ModelsHighLigthResult {
  items?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  hasMore?: boolean;
}

export enum SravniNewsSharedEnumsCommentsSortBy {
  Date = 'date',
}

export enum SravniNewsSharedEnumsDictionaryType {
  Rubrics = 'rubrics',
  ProductTags = 'productTags',
  Tags = 'tags',
}

export enum SravniNewsSharedEnumsExternalMaterialType {
  Unknown = 'unknown',
  Promo = 'promo',
  Qna = 'qna',
}

export enum SravniNewsSharedEnumsMaterialTemplateType {
  Sravni = 'sravni',
  Setka = 'setka',
  LegacyWebFlow = 'legacyWebFlow',
}

export enum SravniNewsSharedEnumsMaterialType {
  Undefined = 'undefined',
  News = 'news',
  Article = 'article',
  PrivateArticle = 'privateArticle',
}

export enum SravniNewsSharedEnumsModerationReasonType {
  None = 'none',
  EmailContent = 'emailContent',
  PhoneContent = 'phoneContent',
  AbusiveContent = 'abusiveContent',
  Ads = 'ads',
  Spam = 'spam',
  Fraud = 'fraud',
  IncompleteData = 'incompleteData',
  ImageContent = 'imageContent',
  Link = 'link',
  TransliterationContent = 'transliterationContent',
  UnreadableContent = 'unreadableContent',
  ImportedRequiresConfirmation = 'importedRequiresConfirmation',
  InvalidContentMatching = 'invalidContentMatching',
}

export enum SravniNewsSharedEnumsPlacementType {
  ArticlesList = 'articlesList',
  HomePage = 'homePage',
  EndlessScroll = 'endlessScroll',
  AdditionalReading = 'additionalReading',
  NewsList = 'newsList',
  UsefulReading = 'usefulReading',
  PartnerMaterials = 'partnerMaterials',
  SpecialProjects = 'specialProjects',
}

export interface SravniNewsSharedModelsAuthorCertificateReadModel {
  text?: string | null;
  link?: string | null;
  /** @format int32 */
  position?: number;
}

export interface SravniNewsSharedModelsAuthorPublicationsReadModel {
  text?: string | null;
  link?: string | null;
  /** @format int32 */
  position?: number;
  icon?: string | null;
}

export interface SravniNewsSharedModelsAuthorsAuthorReadModel {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  wpId?: number;
  displayName?: string | null;
  email?: string | null;
  description?: string | null;
  education?: string | null;
  workExperience?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  vk?: string | null;
  ok?: string | null;
  telegram?: string | null;
  title?: string | null;
  isExpert?: boolean;
  /** @format int32 */
  age?: number;
  /** @format int64 */
  rating?: number;
  certificates?: SravniNewsSharedModelsAuthorCertificateReadModel[] | null;
  publications?: SravniNewsSharedModelsAuthorPublicationsReadModel[] | null;
  rubrics?: SravniNewsSharedModelsNameAliasModel[] | null;
  /** @format int32 */
  materialsCount?: number;
  /** @format int32 */
  commentsCount?: number;
  lastName?: string | null;
}

export interface SravniNewsSharedModelsCommentsAuthorMaterialInfoModel {
  /** @format int64 */
  id?: number;
  alias?: string | null;
  rubricType?: string | null;
  rubric?: string | null;
  tags?: string[] | null;
  organizationId?: string | null;
  externalUrl?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
  /** @format date-time */
  publishDate?: string;
}

export interface SravniNewsSharedModelsCommentsCommentReadModel {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  created?: string;
  /** @format int64 */
  postId?: number;
  /** @format int64 */
  parentId?: number | null;
  text?: string | null;
  /** @format int32 */
  userId?: number;
  userName?: string | null;
  userLastName?: string | null;
  email?: string | null;
  phone?: string | null;
  /** @format int32 */
  commentsCount?: number;
  moderationReasons?: SravniNewsSharedEnumsModerationReasonType[] | null;
  /** @format int64 */
  likes?: number;
  canEdit?: boolean;
  canDelete?: boolean;
  isLiked?: boolean;
  materialInfo?: SravniNewsSharedModelsCommentsAuthorMaterialInfoModel;
}

export interface SravniNewsSharedModelsCommentsCommentUpdateModel {
  /** @format int64 */
  postId?: number;
  /** @format int64 */
  parentId?: number | null;
  text?: string | null;
}

export interface SravniNewsSharedModelsCommentsPostCommentsCount {
  /** @format int64 */
  postId?: number;
  /** @format int32 */
  commentsCount?: number;
}

export interface SravniNewsSharedModelsCommentsPostLikesCount {
  /** @format int64 */
  postId?: number;
  /** @format int32 */
  likesCount?: number;
}

export interface SravniNewsSharedModelsLikesLikeInfo {
  /** @format int64 */
  targetId?: number;
  like?: boolean;
}

export interface SravniNewsSharedModelsLikesLikeUpdateModel {
  /** @format int64 */
  postId?: number;
  /** @format int64 */
  entityId?: number;
  fingerPrint?: string | null;
}

export interface SravniNewsSharedModelsLikesUserLikesResult {
  materials?: SravniNewsSharedModelsLikesLikeInfo[] | null;
  comments?: SravniNewsSharedModelsLikesLikeInfo[] | null;
}

export interface SravniNewsSharedModelsLimitModel1SravniNewsSharedModelsMaterialsHighLightSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  total?: number;
  items?: SravniNewsSharedModelsMaterialsHighLight[] | null;
}

export interface SravniNewsSharedModelsMaterialsHighLight {
  /** @format int32 */
  id?: number;
  rubric?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
  title?: string | null;
  alias?: string | null;
  lead?: string | null;
  miniPicture?: string | null;
  /** @format int32 */
  views?: number;
  /** @format date-time */
  pubDate?: string;
  noIndex?: boolean;
  body?: string | null;
  url?: string | null;
  isExternal?: boolean;
  externalId?: string | null;
  externalType?: SravniNewsSharedEnumsExternalMaterialType;
  /** @format int32 */
  commentsCount?: number;
  authorName?: string | null;
  authorLastName?: string | null;
  tags?: string[] | null;
  organizationData?: SravniOrganizationsSharedOrganizationData;
  /** @format int32 */
  priorityOnMain?: number;
  /** @format int32 */
  priorityOnList?: number;
  /** @format int32 */
  priorityOnScroll?: number;
  /** @format int32 */
  priorityOnAdditionalReading?: number;
  /** @format int64 */
  likes?: number;
}

export interface SravniNewsSharedModelsMaterialsMaterialInfoModel {
  /** @format int64 */
  id?: number;
  alias?: string | null;
  rubricType?: string | null;
  rubric?: string | null;
  tags?: string[] | null;
  organizationId?: string | null;
  externalUrl?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
}

export interface SravniNewsSharedModelsMaterialsMaterialsInfoModel {
  /** @format date-time */
  publishDate?: string;
  items?: SravniNewsSharedModelsMaterialsMaterialInfoModel[] | null;
}

export enum SravniNewsSharedModelsMaterialsOrderBy {
  PublishDate = 'publishDate',
  Visits = 'visits',
}

export interface SravniNewsSharedModelsMaterialsTopFreshHighLights {
  tops?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  mids?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  juniors?: SravniNewsSharedModelsMaterialsHighLight[] | null;
}

export interface SravniNewsSharedModelsNameAliasModel {
  /** @format int64 */
  id?: number;
  name?: string | null;
  alias?: string | null;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsDataModelsMaterialSravniNewsDataVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsDataModelsMaterial[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsDataModelsUserContentReadModelSravniNewsDataVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsDataModelsUserContentReadModel[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsDomainAuthorBlockSravniNewsDomainVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsDomainAuthorBlock[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsSharedModelsCommentsCommentReadModelSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsSharedModelsCommentsCommentReadModel[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsSharedModelsMaterialsHighLightSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsViewsViewInfo {
  /** @format int64 */
  targetId?: number;
  /** @format int64 */
  views?: number;
}

export interface SravniOrganizationsSharedOrganizationData {
  id?: string | null;
  mongoId?: string | null;
  /** @format int32 */
  oldId?: number | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  alias?: string | null;
  status?: SravniOrganizationsSharedOrganizationStatus;
  name?: string | null;
  deleted?: boolean;
  isRecomended?: boolean | null;
  type?: SravniOrganizationsSharedOrganizationType;
  logotype?: string | null;
}

export enum SravniOrganizationsSharedOrganizationStatus {
  Absorbed = 'absorbed',
  Active = 'active',
  Archived = 'archived',
  Hidden = 'hidden',
}

export enum SravniOrganizationsSharedOrganizationType {
  Unknown = 'unknown',
  Bank = 'bank',
  Insurance = 'insurance',
  Mfo = 'mfo',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
  Investment = 'investment',
  NonbankingOrganization = 'nonbankingOrganization',
  MortgageAgent = 'mortgageAgent',
  Other = 'other',
  FoodRation = 'foodRation',
}

export enum SravniOrganizationsSharedReviewObjectType {
  Unknown = 'unknown',
  Banks = 'banks',
  InsuranceCompany = 'insuranceCompany',
  CarService = 'carService',
  CarModel = 'carModel',
  Mfi = 'mfi',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
  Investment = 'investment',
  FoodRation = 'foodRation',
}

export interface MaterialsAuthorsListParams {
  DisplayName?: string;
  IncludeRating?: boolean;
  IsEditor?: boolean;
}

export interface AuthorGetIdentityUserListParams {
  email?: string;
  phone?: string;
}

export interface AuthorCheckInIdentityListParams {
  email?: string;
  phone?: string;
}

export interface AuthorsBlocksListParams {
  /** @format int64 */
  AuthorId?: number;
  Term?: string;
  IsBlocked?: boolean;
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
}

export interface AuthorBlockCreateParams {
  /** @minLength 10 */
  cause: string;
  /** @format int32 */
  id: number;
}

export interface BackofficeCommentsListParams {
  /** @format date-time */
  From?: string;
  /** @format date-time */
  To?: string;
  /** @format int64 */
  PostId?: number;
  MaterialTitle?: string;
  /** @format int64 */
  ParentId?: number;
  Text?: string;
  UserName?: string;
  Email?: string;
  Phone?: string;
  ModerationReasonType?: SravniNewsSharedEnumsModerationReasonType;
  IsDeleted?: boolean;
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
}

export interface CommentsListParams {
  /** @format int64 */
  PostId: number;
  /** @format int64 */
  ParentId?: number;
  /** @format int32 */
  Skip?: number;
  SortBy?: SravniNewsSharedEnumsCommentsSortBy;
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
  fingerPrint?: string;
}

export interface CommentsAuthorDetailParams {
  SortByCreatedDateDesc?: boolean;
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
  /** @format int32 */
  id: number;
}

export interface CommentsCountListParams {
  /** @maxItems 50 */
  postIds?: number[];
}

export interface TagsListParams {
  term?: string;
}

export interface DictionaryListParams {
  type?: SravniNewsSharedEnumsDictionaryType;
}

export interface RubricsListParams {
  placement?: SravniNewsSharedEnumsPlacementType;
}

export interface RubricTagsListParams {
  rubric:
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy';
}

export interface FeedsListParams {
  feedType?:
    | 'tinkoff-invest'
    | 'yandex-news'
    | 'yandex-zen'
    | 'yandex-search'
    | 'pulse'
    | 'vmetro'
    | 'google-news'
    | 'vkontakte'
    | 'rambler'
    | 'instagram';
  rubricAlias?: string[];
  tagAlias?: string[];
}

export interface AdditionalReadingHighlightsListParams {
  Alias?: string;
  IsWebFlow?: boolean;
  TinkoffInvestments?: boolean;
  Vmetro?: boolean;
  MostInteresting?: boolean;
  IsPreview?: boolean;
  IsYandexZen?: boolean;
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  IncludeExternal?: boolean;
  /** @format int32 */
  MinimalViewsFrom?: number;
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'rko'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'biznes-kredity'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-accounting'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface ExternalMaterialsListParams {
  Alias?: string;
  IsWebFlow?: boolean;
  TinkoffInvestments?: boolean;
  Vmetro?: boolean;
  MostInteresting?: boolean;
  IsPreview?: boolean;
  IsYandexZen?: boolean;
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  IncludeExternal?: boolean;
  /** @format int32 */
  MinimalViewsFrom?: number;
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'rko'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'biznes-kredity'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-accounting'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface MaterialsPopularHighlightsListParams {
  /** @format int32 */
  Limit?: number;
  Placement?: SravniNewsSharedEnumsPlacementType;
  Rubric?:
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy';
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  /** @format int32 */
  PlacementLimit?: number;
}

export interface MaterialsHighlightsListParams {
  Rubric?:
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy';
  Placement?: SravniNewsSharedEnumsPlacementType;
  IncludeBody?: boolean;
  /** @format date-time */
  DateTo?: string;
  Tags?: string[];
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Limit?: number;
}

export interface MaterialsHighlightsNewsListParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Limit?: number;
}

export interface MaterialsAuthorDetailParams {
  Text?: string;
  /** @format int32 */
  Limit?: number;
  /** @format int32 */
  Skip?: number;
  MaterialType?: SravniNewsSharedEnumsMaterialType;
  Tags?: string[];
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  /** @format int32 */
  userId: number;
}

export interface MaterialsOrganizationHighlightsListParams {
  OrganizationIds?: string[];
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'rko'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'biznes-kredity'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-accounting'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface HeadV12Params {
  /**
   * @format int64
   * @default 0
   */
  entityId?: number;
  /** @format int64 */
  postId: number;
}

export interface LikesCountListParams {
  postIds?: number[];
}

export interface LikesDeleteParams {
  /** @format int64 */
  PostId?: number;
  /** @format int64 */
  EntityId?: number;
  FingerPrint?: string;
}

export interface UserSelfLikesListParams {
  fingerPrint?: string;
}

export interface MaterialsPopularListParams {
  /** @format int32 */
  Limit?: number;
  Placement?: SravniNewsSharedEnumsPlacementType;
  Rubric?:
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy';
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  /** @format int32 */
  PlacementLimit?: number;
}

export interface MaterialsListParams {
  Alias?: string;
  IsWebFlow?: boolean;
  TinkoffInvestments?: boolean;
  Vmetro?: boolean;
  MostInteresting?: boolean;
  IsPreview?: boolean;
  IsYandexZen?: boolean;
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  IncludeExternal?: boolean;
  /** @format int32 */
  MinimalViewsFrom?: number;
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'rko'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'biznes-kredity'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-accounting'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface MaterialsSingleListParams {
  Alias: string;
  /** @format date-time */
  Created?: string;
  Unpublished?: boolean;
  IsWebFlowOnly?: boolean;
}

export interface MaterialsInfoListParams {
  /** @format date-time */
  From?: string;
  /** @format date-time */
  To?: string;
}

export interface MaterialsOpensearchSearchListParams {
  Term?: string;
  /** @format date-time */
  DateFrom?: string;
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
}

export interface OrganizationsInfoListParams {
  /** @default false */
  activeOnly?: boolean;
}

export interface MaterialsOrganizationListParams {
  OrganizationIds?: string[];
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  Rubrics?: (
    | 'all'
    | 'novosti-partnerov'
    | 'novosti'
    | 'novosti-sporta'
    | 'putevoditel'
    | 'specproekty'
    | 'sport'
    | 'biznes'
    | 'pravo'
    | 'lgoty'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'rko'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'biznes-kredity'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-accounting'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface OrganizationsPartnersInfoListParams {
  /**
   * @format int32
   * @default 6
   */
  take?: number;
  /**
   * @format int32
   * @default 7
   */
  activityDays?: number;
}

export interface ActivityByServiceDetailParams {
  /** @format int32 */
  PageIndex?: number;
  /** @format int32 */
  PageSize?: number;
  /** @format int32 */
  id: number;
}

export interface ViewsCountListParams {
  postIds?: number[];
}
